import React, { PureComponent } from 'react';
import { Portal, Segment, Header, Button } from 'semantic-ui-react';

export default class NotificationPortal extends PureComponent {
  render() {
    const {
      openSavedNotificationPortal,
      notificationMessage,
      handleCloseNotificationPortal,
      isError,
    } = this.props;
    return (
      <Portal onClose={handleCloseNotificationPortal} open={openSavedNotificationPortal}>
        <Segment
          style={{
            left: '40%',
            position: 'fixed',
            top: '40%',
            zIndex: 1000,
          }}
        >
          <Header>
            {notificationMessage
              ? notificationMessage.split('\n').map((item, i) => <p key={i}>{item}</p>)
              : ''}
          </Header>

          {notificationMessage &&
            (notificationMessage.split('\n').length === 1 && !isError ? (
              <Button content="OK" positive onClick={handleCloseNotificationPortal} />
            ) : (
              <Button content="OK" negative onClick={handleCloseNotificationPortal} />
            ))}
        </Segment>
      </Portal>
    );
  }
}
